<template>
  <div class="operationManager">
    <div class="main">
      <div class="left">
        <patientsForm></patientsForm>
      </div>
      <div class="right">
        <div class="rightRop">
          <ElectiveOperation></ElectiveOperation>
        </div>
        <div class="tightBottom">
          <ElectiveOperationList></ElectiveOperationList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import patientsForm from "./PatientsForm.vue";
import ElectiveOperation from "./ElectiveOperation.vue";
import ElectiveOperationList from "./ElectiveOperationList.vue";
import popMixins from "../utils/popMixins.js";

export default {
  components: {
    patientsForm,
    ElectiveOperation,
    ElectiveOperationList
  },
  mixins:[popMixins],
  computed: {
    getOperationClear() {
      return this.$store.getters.getOperationClear;
    },
    geteditOperation() {
      return this.$store.state.editOperation;
    }
  },
  beforeDestroy() {
    this.$store.commit("seteditOperation", false);
  },
  watch: {
    // geteditOperation(newVal) {
    //   if (!newVal) {
    //     this.$store.commit("setoperationElectiveId", "");
    //     this.$store.commit("setoperationRelevantId", "");
    //     this.$store.commit("setoperationPatientId", "");
    //   }
    // },
    getOperationClear(newVal) {
      if (newVal) {
        this.$store.commit("setoperationClearClick", false);
        this.$store.commit("setoperationFormElectiveStatus", false);
        this.$store.commit("setoperationFormRelevantStatus", false);
        this.$store.commit("setoperationFormPatientStatus", false);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.operationManager {
  width: 100%;
  height: 100%;
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    .left {
      width: 336px;
      height: 100%;
      background: #eff2f7;
    }
    .right {
      height: 100%;
      width: calc(~"100% - 336px");
      padding: 0 25px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .tightBottom {
        margin-top: 10px;
        height: calc(~"100% - 202px") !important;
      }
    }
  }
}
</style>
